module.exports = __webpack_public_path__ + "img/IMG_7189_FoamcoreMatted.438e9e09.jpg";